import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

const ChannelListArrowLeftContainer = styled.div`
  position: fixed;
  top: ${523 * Screen.widthRatio}px;
  left: ${12 * Screen.widthRatio}px;
`;

export default withOpacity(ChannelListArrowLeftContainer);
